import { React, useState } from "react";
import './bookingShared.css';
import './bookingStep1.css';

const TICKET_TYPES = [
  {
    id: "day",
    name: "One Day Pass",
    price: "EGP 9.00",
    description:
      "- Entrance: From Gate 1, 2, 3, and 4 - Egypt International Exhibition Center. - Doors Open: From 10 AM to 8 PM daily, and from 10 AM to 9 PM on Thursdays and Fridays.",
  },
  {
    id: "vip",
    name: "VIP",
    price: "EGP 200.00",
    description:
      "- Dedicated Entrance with Parking: From Gate 7 - Egypt International Exhibition Center. - Doors Open: From 10 AM to 8 PM daily, and from 10 AM to 9 PM on Thursdays and Fridays.",
  },
];

export default function BookingStep1({ onNext, schedule }) {
  const [date, setDate] = useState("");
  const [ticketType, setTicketType] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [openDetails, setOpenDetails] = useState(null);
  const [errors, setErrors] = useState({});

  const minDate = schedule?.exhibition_start_date || "2027-01-25";
  const maxDate = schedule?.exhibition_end_date || "2027-02-07";
  const maxTickets = schedule?.max_tickets_per_booking || 10;

  function formatDate(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  function handleDetailsToggle(e, id) {
    e.stopPropagation();
    setOpenDetails((prev) => (prev === id ? null : id));
  }

  function handleSubmit(e) {
    e.preventDefault();

    const newErrors = {};

    if (!date) newErrors.date = "Please select a date.";
    if (!ticketType) newErrors.ticketType = "Please select a ticket type.";

    if (quantity > maxTickets) {
      newErrors.quantity = `Maximum ${maxTickets} tickets per booking.`;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ date, ticketType, quantity });
  }

  return (
    <form className="bookingForm" onSubmit={handleSubmit} noValidate>
      <div className="bookField">
        <label className="bookLabel" htmlFor="bookingDate">
          Select Date <span className="req">*</span>
        </label>

        <input
          id="bookingDate"
          type="date"
          className={errors.date ? "inputError" : ""}
          value={date}
          min={minDate}
          max={maxDate}
          onChange={(e) => {
            setDate(e.target.value);
            setErrors((prev) => ({ ...prev, date: undefined }));
          }}
        />

        {errors.date ? (
          <p className="fieldError">{errors.date}</p>
        ) : (
          <p className="fieldHint">
            Fair runs from {formatDate(minDate)} – {formatDate(maxDate)}
          </p>
        )}
      </div>

      <div className="bookField">
        <span className="bookLabel">
          Ticket Type <span className="req">*</span>
        </span>

        <div className="ticketGrid">
          {TICKET_TYPES.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`ticketCard ${ticketType === t.id ? "selected" : ""} ${errors.ticketType ? "inputError" : ""}`}
              onClick={() => {
                setTicketType(t.id);
                setErrors((prev) => ({ ...prev, ticketType: undefined }));
              }}
            >
              <div className="ticketTop">
                <span className="ticketName">{t.name}</span>
                <div className="radioCircle">
                  <div className="radioInner" />
                </div>
              </div>

              <p className="ticketPrice">{t.price}</p>

              <button
                type="button"
                className="viewDetailsBtn"
                onClick={(e) => handleDetailsToggle(e, t.id)}
              >
                <span className={`plusIcon ${openDetails === t.id ? "open" : ""}`}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 1v10M1 6h10" stroke="white" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </span>
                View details
              </button>

              <div className={`detailsPanel ${openDetails === t.id ? "open" : ""}`}>
                <p className="detailsInner">{t.description}</p>
              </div>
            </button>
          ))}
        </div>

        {errors.ticketType && <p className="fieldError">{errors.ticketType}</p>}
      </div>

      <div className="bookField">
        <label className="bookLabel" htmlFor="ticketQty">
          Number of Tickets <span className="req">*</span>
        </label>

        <div className="counterRow">
          <button
            type="button"
            className="counterBtn"
            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
            disabled={quantity <= 1}
            aria-label="Decrease quantity"
          >
            −
          </button>

          <input
            id="ticketQty"
            type="number"
            className={errors.quantity ? "counterInput inputError" : "counterInput"}
            value={quantity}
            min={1}
            max={maxTickets}
            readOnly
          />

          <button
            type="button"
            className="counterBtn"
            onClick={() => setQuantity((q) => Math.min(maxTickets, q + 1))}
            disabled={quantity >= maxTickets}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>

        {errors.quantity ? (
          <p className="fieldError">{errors.quantity}</p>
        ) : (
          <p className="fieldHint">Maximum {maxTickets} tickets per booking</p>
        )}
      </div>

      <div className="formFooter">
        <button type="submit" className="nextBtn">Next</button>
      </div>
    </form>
  );
}